import { Button, Text } from "@ttc3k/trekker";
import { useTranslation } from "react-i18next";
import { formatPrice } from "shared/utils";
import { Box } from "styled-system/jsx";
import { useBookerContext, useCartContext } from "widgets/booker/contexts";
import { getCartDiscountNudge } from "./getCartDiscountNudge";

export const CatalogCartBar = ({ onCheckout }: { onCheckout: () => void }) => {
  const { cart, subTotal } = useCartContext();
  const { booker } = useBookerContext();
  const { t } = useTranslation("booker", { keyPrefix: "MERCH_CATALOG" });

  const itemCount = cart.reduce((sum, item) => sum + item.quantity, 0);
  if (itemCount === 0) return null;

  const preDiscountTotal = cart.reduce((sum, item) => sum + item.total, 0);
  const total = subTotal || preDiscountTotal;
  const nudge = getCartDiscountNudge(
    booker?.discounts ?? [],
    itemCount,
    preDiscountTotal,
  );

  const nudgeText = !nudge
    ? null
    : nudge.kind === "quantity"
      ? t("NUDGE_QUANTITY", {
          count: nudge.itemsNeeded,
          discount: nudge.discount,
        })
      : nudge.kind === "spend"
        ? t("NUDGE_SPEND", {
            amount: nudge.amountNeeded,
            discount: nudge.discount,
          })
        : t(nudge.isFree ? "NUDGE_BOGO_FREE" : "NUDGE_BOGO", {
            count: nudge.itemsNeeded,
            discount: nudge.discount,
          });

  return (
    <Box
      position="sticky"
      bottom="0"
      zIndex={2}
      px="300"
      pt="300"
      bg="ink.100"
      borderTopWidth="1px"
      borderTopStyle="solid"
      borderTopColor="border.light"
      style={{ paddingBottom: "max(16px, env(safe-area-inset-bottom))" }}
    >
      {nudgeText && (
        <Text
          visual="smallMedium"
          color="text.accent.blue.dark"
          textAlign="center"
          mb="200"
          aria-live="polite"
        >
          {nudgeText}
        </Text>
      )}
      <Button size="lg" w="full" type="button" onClick={onCheckout}>
        {t("CHECKOUT_ITEMS", { count: itemCount })}&nbsp;·&nbsp;$
        {formatPrice(total)}
      </Button>
    </Box>
  );
};
